import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ActionSheetController, LoadingController, ModalController, ToastController } from 'ionic-angular';
import { BusinessProductPaymentCheckoutPage } from '../business-product-payment-checkout/business-product-payment-checkout';
import { BusinessProductPaymentManagerHandler } from '../../providers/business-product-payment-handler';
import { ConsumerHandlerProvider } from '../../providers/consumer-handler';
import { ProductPaymentCheckoutHandler } from '../../providers/product-payment-checkout-handler';
import { BarcodeScanner, BarcodeScannerOptions } from '@ionic-native/barcode-scanner';
import { Globals } from '../../providers/globals';
import { BusinessProductSearchPage } from '../business-product-search/business-product-search';
import { BusinessProductCategoryPage } from '../business-product-category/business-product-category';
/**
 * Generated class for the BusinessProductPaymentManagerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-business-product-payment-manager',
  templateUrl: 'business-product-payment-manager.html',
})
export class BusinessProductPaymentManagerPage {
	groups: any = [{
		index: 0,
		products: [],
		paymentTypeId: null
	}]

	categories: any;
	selectedCategories: any;
	paymentTypes: any;
	selectedProducts: any = [];
	orderTotal: any = 0;
	consumer: any;
	businessId: any = 0;

	hasProducts: boolean = false;
	filePath: any;
	loader: any;
	isLoading: boolean = false;
	loadingMsg: any = "Loading...";
	userIsLoading: boolean = false

	params: any = {
		page: 1,
		size: 20,
		cb: null
	}

	paymentMethod: any = null;
	hasOtherPaymentMethods: boolean = false;

	options: BarcodeScannerOptions;
	results: {
	    text: string,
	    cancelled: boolean
	};

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams,
		public productManagerHandler: BusinessProductPaymentManagerHandler,
		public consumerHandlerProvider: ConsumerHandlerProvider,
		public checkoutHandler: ProductPaymentCheckoutHandler,
		public alertCtrl: AlertController,
		public loadingCtrl: LoadingController,
		public actionSheetCtrl: ActionSheetController,
		public modalCtrl: ModalController,
		public toastCtrl: ToastController,
		public globals: Globals,
		private barcodeScanner: BarcodeScanner
		) {
		this.filePath = this.globals.fileUrl;
	}

	ionViewDidLoad(){
		// this.productManagerHandler.getPaymentTypes((result)=>{
		// 	this.paymentTypes = result;

		// 	var nonVirtualMethods = this.paymentTypes.filter(function(item) {
		// 	    return item.IsVirtual == false;
		// 	});

		// 	this.hasOtherPaymentMethods = nonVirtualMethods.length > 0;
		// })

		this.checkoutHandler.activeGroupIndex = null;

   	this.checkoutHandler.order.total = 0;

   	for(var group of this.checkoutHandler.order.groups){
   		this.checkoutHandler.order.total += group.total ? group.total : 0;
   	}
	}

	presentSearchModal(group) {
		 this.checkoutHandler.activeGroupIndex = group.index;

	   let searchModal = this.modalCtrl.create(BusinessProductSearchPage, {});

	   searchModal.onDidDismiss(group => {
	   	this.checkoutHandler.activeGroupIndex = null;

	   	this.checkoutHandler.order.total = 0;

	   	for(var group of this.checkoutHandler.order.groups){
	   		this.checkoutHandler.order.total += group.total ? group.total : 0;
	   	}
	   });

	   searchModal.present();
	 }
	
	clearOrder(){
		this.checkoutHandler.clearOrder()
	}

	clearCustomer(){
		this.checkoutHandler.clearOrder()
	}

	selectProduct($e, product) {

		product.Count = product.Count ? product.Count + 1 : 1;

		this.checkoutHandler.order.total += product.Price;

		// this.checkoutHandler.order.products.push(product)
	}

	removeProduct($e, product) {

		this.checkoutHandler.order.total -= product.Price;

		product.Count = product.Count ? product.Count - 1 : 0;

		// if(product.Count == 0) {
		// 	this.checkoutHandler.order.products = this.checkoutHandler.order.products.filter(function(item) {
		// 	    return item.Id != product.Id;
		// 	});
		// }
	}

	testScanDevice(id){
		var userInfo = [1186, 57]

      	var userParams = {};

		if(userInfo.length>2){
			userParams = {
				businessId: userInfo[0],
				userId: userInfo[1],
				deviceId: 0
			};
		}else{
			userParams = {
				businessId: userInfo[0],
				userId: 0,
				deviceId: userInfo[1]
			}					
		}

    	this.checkoutHandler.order.businessId = 1186

    	this.checkoutHandler.order.paymentTypeId = 2;

		this.productManagerHandler.getUser(userParams, (result)=>{
	  	
		  	if(result && result.UserId > 0){
		  		this.checkoutHandler.order.consumer = result
		  	} else {

		  		let toast = this.toastCtrl.create({
					message: 'User has not purchased credits',
					duration: 3000,
					position: 'middle'
				});

				toast.present();	

				this.checkoutHandler.order.paymentTypeId = null
		  	}

		  	this.userIsLoading = false;
		})
	}

	async scanDevice(paymentTypeId){
		this.userIsLoading = true

		this.options = {
		  prompt: 'Scan a user to get his account'
		}


		try{
			this.barcodeScanner.scan().then(results => {
				console.log("Payment type: " + paymentTypeId);
	
			 	console.log('Barcode text', results.text);
			 	this.results = results;

				if(this.results.cancelled == true){
					this.userIsLoading = false
					return;
				}

				var userInfo = this.results.text.split("-");

				this.userIsLoading = false
				
				var userParams = {
					businessId: {},
					userId: {},
					deviceId: {}					
				};

				if(userInfo.length>2){
					userParams = {
						businessId: userInfo[0],
						userId: userInfo[1],
						deviceId: 0
					};
				}else{
					userParams = {
						businessId: userInfo[0],
						userId: 0,
						deviceId: userInfo[1]
					}					
				}

				console.log('userInfo.length: ', userInfo.length);
				console.log('userParams.userId: ', userParams.userId);
				console.log('userParams.deviceId: ', userParams.deviceId);

			  	this.checkoutHandler.order.businessId = parseInt(userInfo[0]);

				this.productManagerHandler.getUser(userParams, (result)=>{			  	
				  	if(result && result.UserId > 0){
				  		this.checkoutHandler.order.paymentTypeId = paymentTypeId

			  			this.checkoutHandler.order.consumer = result
				  	} else {
				  		
				  		let toast = this.toastCtrl.create({
							message: 'User has not purchased credits',
							duration: 3000,
							position: 'middle'
						});

						toast.present();	
				  	}

				  	this.userIsLoading = false;
				})

			}).catch(err => {
			    console.log('Error', err);
			});


		}catch(e){
			this.userIsLoading = false
		}
  }

  startOther(paymentMethod) {

  		this.checkoutHandler.order.paymentTypeId = paymentMethod;

		// this.productManagerHandler.getBusinessUser((result)=>{
	  	
		//   	if(result && result.UserId > 0){
		//   		this.checkoutHandler.order.consumer = result
		//   	} else {

		//   		let toast = this.toastCtrl.create({
		// 			message: 'User has not purchased credits',
		// 			duration: 3000,
		// 			position: 'middle'
		// 		});

		// 		toast.present();	
		//   	}

		//   	this.userIsLoading = false;
		// })
  }

  removeGroup(group){
  // 	if(group.Count == 0) {
		// 	this.checkoutHandler.order.products = this.checkoutHandler.order.products.filter(function(item) {
		// 	    return item.Id != product.Id;
		// 	});
		// }
  }

  goToCheckout(){
  	this.checkoutHandler.order.total = 0;
  	this.checkoutHandler.order.products = [];

  	for(var group of this.checkoutHandler.order.groups){

  		this.checkoutHandler.order.total += group.total ? group.total : 0;

  		for(var product of this.checkoutHandler.order.groups[0].products){
	   			for (var i = 0; i < product.Count; i++) { 
					  this.checkoutHandler.order.products.push(product)
					}
	   	}	
	   }

	  if(this.checkoutHandler.order.products.length > 0){

	  	this.navCtrl.push(BusinessProductPaymentCheckoutPage, {
		      "parentPage": this
		    });
		}
  }

  addOrder(){
  	var groupObj = {
  		index: this.checkoutHandler.order.groups.length,
  		products: []
  	}

  	this.checkoutHandler.order.groups.push(groupObj)
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-product-payment-manager/business-product-payment-manager.ts